import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';
import Button from '../../../components/ui/Button';

const FilterSidebar = ({ filters, onFilterChange, onResetFilters, isCollapsed, onToggleCollapse }) => {
  const [savedPresets] = useState([
    { value: 'all', label: 'All Yards' },
    { value: 'high_capacity', label: 'High Capacity (>50)' },
    { value: 'low_utilization', label: 'Low Utilization (<50%)' },
    { value: 'maintenance_due', label: 'Maintenance Due' }
  ]);

  const regionOptions = [
    { value: 'all', label: 'All Regions' },
    { value: 'northeast', label: 'Northeast' },
    { value: 'southeast', label: 'Southeast' },
    { value: 'midwest', label: 'Midwest' },
    { value: 'southwest', label: 'Southwest' },
    { value: 'west', label: 'West' }
  ];

  const statusOptions = [
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
    { value: 'maintenance', label: 'Under Maintenance' }
  ];

  const utilizationOptions = [
    { value: 'all', label: 'All Utilization' },
    { value: 'low', label: 'Low (<50%)' },
    { value: 'medium', label: 'Medium (50-80%)' },
    { value: 'high', label: 'High (>80%)' }
  ];

  if (isCollapsed) {
    return (
      <div className="w-12 bg-card border-r border-border flex flex-col items-center py-4 space-y-4">
        <button
          onClick={onToggleCollapse}
          className="flex items-center justify-center w-8 h-8 text-muted-foreground hover:text-foreground hover:bg-muted/50 rounded-md transition-hover"
          title="Expand filters"
        >
          <Icon name="ChevronRight" size={20} strokeWidth={2} />
        </button>
        <div className="flex items-center justify-center w-8 h-8 text-primary">
          <Icon name="Filter" size={20} strokeWidth={2} />
        </div>
      </div>
    );
  }

  return (
    <div className="w-80 bg-card border-r border-border flex flex-col h-full">
      <div className="flex items-center justify-between px-4 py-3 border-b border-border">
        <div className="flex items-center space-x-2">
          <Icon name="Filter" size={20} color="var(--color-primary)" strokeWidth={2} />
          <h3 className="text-sm font-semibold text-foreground">Filters</h3>
        </div>
        <button
          onClick={onToggleCollapse}
          className="flex items-center justify-center w-8 h-8 text-muted-foreground hover:text-foreground hover:bg-muted/50 rounded-md transition-hover"
          title="Collapse filters"
        >
          <Icon name="ChevronLeft" size={20} strokeWidth={2} />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto p-4 space-y-6">
        <div>
          <Select
            label="Filter Preset"
            options={savedPresets}
            value={filters?.preset}
            onChange={(value) => onFilterChange('preset', value)}
            className="mb-4"
          />
        </div>

        <div>
          <Input
            label="Search Yards"
            type="search"
            placeholder="Yard name or ID..."
            value={filters?.search}
            onChange={(e) => onFilterChange('search', e?.target?.value)}
            className="mb-4"
          />
        </div>

        <div>
          <Select
            label="Region"
            options={regionOptions}
            value={filters?.region}
            onChange={(value) => onFilterChange('region', value)}
            className="mb-4"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-3">Status</label>
          <div className="space-y-2">
            {statusOptions?.map((status) => (
              <Checkbox
                key={status?.value}
                label={status?.label}
                checked={filters?.status?.includes(status?.value)}
                onChange={(e) => {
                  const newStatus = e?.target?.checked
                    ? [...filters?.status, status?.value]
                    : filters?.status?.filter(s => s !== status?.value);
                  onFilterChange('status', newStatus);
                }}
              />
            ))}
          </div>
        </div>

        <div>
          <Select
            label="Utilization"
            options={utilizationOptions}
            value={filters?.utilization}
            onChange={(value) => onFilterChange('utilization', value)}
            className="mb-4"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">Capacity Range</label>
          <div className="grid grid-cols-2 gap-2">
            <Input
              type="number"
              placeholder="Min"
              value={filters?.capacityMin}
              onChange={(e) => onFilterChange('capacityMin', e?.target?.value)}
            />
            <Input
              type="number"
              placeholder="Max"
              value={filters?.capacityMax}
              onChange={(e) => onFilterChange('capacityMax', e?.target?.value)}
            />
          </div>
        </div>
      </div>
      <div className="px-4 py-3 border-t border-border">
        <Button
          variant="outline"
          fullWidth
          iconName="RotateCcw"
          iconPosition="left"
          onClick={onResetFilters}
        >
          Reset Filters
        </Button>
      </div>
    </div>
  );
};

export default FilterSidebar;